import { supabase } from '../lib/supabase';

export class AuthService {
  private static readonly ADMIN_SESSION_KEY = 'la_admin_session';

  static async login(username: string, password: string): Promise<boolean> {
    try {
      const { data, error } = await supabase.functions.invoke('admin-auth', {
        body: { username, password }
      });

      if (error) {
        console.error('Login error:', error);
        return false;
      }

      if (data && data.success) {
        // Store session with token
        const session = {
          user: data.user,
          token: data.token,
          loginTime: new Date().toISOString(),
          expires: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString()
        };

        localStorage.setItem(this.ADMIN_SESSION_KEY, JSON.stringify(session));
        return true;
      }

      return false;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  }

  static logout(): void {
    localStorage.removeItem(this.ADMIN_SESSION_KEY);
  }

  static isAuthenticated(): boolean {
    try {
      const sessionData = localStorage.getItem(this.ADMIN_SESSION_KEY);
      if (!sessionData) return false;

      const session = JSON.parse(sessionData);
      const now = new Date();
      const expires = new Date(session.expires);

      return expires > now;
    } catch {
      return false;
    }
  }

  static getSession() {
    try {
      const sessionData = localStorage.getItem(this.ADMIN_SESSION_KEY);
      return sessionData ? JSON.parse(sessionData) : null;
    } catch {
      return null;
    }
  }

  static extendSession(): void {
    const session = this.getSession();
    if (session) {
      session.expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString();
      localStorage.setItem(this.ADMIN_SESSION_KEY, JSON.stringify(session));
    }
  }
}

export default AuthService;
